var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUnpinForUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22433_24753",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22433_24753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8246 15.7385L8.19383 17.9308C8.08741 17.9834 7.9887 18.0045 7.89768 17.9942C7.80665 17.984 7.71818 17.9526 7.63228 17.9C7.5464 17.8475 7.48101 17.7721 7.43613 17.674C7.39126 17.576 7.38742 17.4699 7.4246 17.3558L8.38998 13.2462L5.19575 10.475C5.106 10.4019 5.0467 10.3144 5.01785 10.2125C4.98902 10.1106 4.99511 10.0128 5.03613 9.91925C5.07716 9.82565 5.13229 9.74937 5.20153 9.6904C5.27074 9.63142 5.36433 9.59167 5.48228 9.57115L9.69768 9.20385L11.3419 5.31155C11.3868 5.20128 11.4519 5.12179 11.5371 5.07307C11.6224 5.02436 11.7182 5 11.8246 5C11.931 5 12.0269 5.02436 12.1121 5.07307C12.1974 5.12179 12.2624 5.20128 12.3073 5.31155L13.9515 9.20385L18.1669 9.57115C18.2849 9.59167 18.3785 9.63142 18.4477 9.6904C18.5169 9.74937 18.572 9.82565 18.6131 9.91925C18.6541 10.0128 18.6602 10.1106 18.6314 10.2125C18.6025 10.3144 18.5432 10.4019 18.4535 10.475L15.2592 13.2462L16.2246 17.3558C16.2618 17.4699 16.2579 17.576 16.2131 17.674C16.1682 17.7721 16.1028 17.8475 16.0169 17.9C15.931 17.9526 15.8426 17.984 15.7515 17.9942C15.6605 18.0045 15.5618 17.9834 15.4554 17.9308L11.8246 15.7385Z",
    fill: "#80A9D7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpinForUser);
export default __webpack_public_path__ + "static/media/icon-unpin-for-user.876d1fcecc0446be63de873b36fbacb1.svg";
export { ForwardRef as ReactComponent };